import { memo, useCallback, useContext, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import { mdiChevronDown } from '@mdi/js'
import Icon from '@mdi/react'

import { Context } from 'components/LocalizationWrapper/LocalizationWrapper'
import { LANG_OPTIONS } from 'app/consts'
import { displayFullLanguage, displayLangCode } from 'app/utils/displayLangCode'
import { flags } from 'lang/flags'
import Options from './Options'
import {
  Container,
  LanguageLabelContainer,
  ChevronContainer,
  LangLabel,
  SelectedFlagImage,
} from './styles'
import theme from 'theme_'

interface LanguageSelectorProps {
  mobileClickHandler?: () => void
  isMobileMode?: boolean
}

function LanguageSelector(props: LanguageSelectorProps) {
  const context = useContext(Context)
  const currentAppLanguage = localStorage.getItem('sav-language')

  const [isOpen, setIsOpen] = useState(props.isMobileMode ? true : false)
  const [language, setLanguage] = useState<string>(
    currentAppLanguage || navigator.language
  )

  const handleOpenToggle = useCallback(() => setIsOpen(!isOpen), [isOpen])

  const onSelectedChange = (lang: string) => {
    setLanguage(lang)
    context.selectLanguage(lang)
  }

  return props.isMobileMode ? (
    <Options
      items={LANG_OPTIONS}
      selectedLang={language}
      isOpen={isOpen}
      onSelectedChange={(lang: string) => onSelectedChange(lang)}
    />
  ) : (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <Container onClick={props.mobileClickHandler || handleOpenToggle}>
        <LanguageLabelContainer>
          <div>
            <SelectedFlagImage alt="" src={flags[language]} />
            <LangLabel>
              {props.mobileClickHandler
                ? displayFullLanguage(language)
                : displayLangCode(language)}
            </LangLabel>
          </div>

          <ChevronContainer isOpen={isOpen}>
            <Icon
              path={mdiChevronDown}
              color={theme.colors.lightGrey}
              size={1}
            />
          </ChevronContainer>
        </LanguageLabelContainer>

        <Options
          items={LANG_OPTIONS}
          selectedLang={language}
          isOpen={isOpen}
          onSelectedChange={(lang: string) => onSelectedChange(lang)}
        />
      </Container>
    </OutsideClickHandler>
  )
}

export default memo(LanguageSelector)
